import { formSchema } from "../../validaciones/validacionPreferencias";

export const preferenciasSlice = (set,get) => ({
    insertarPreferencia: () => {
        const result = formSchema.safeParse({ ...get().datos });
        if (!result.success) {
            console.log(result.error.errors);
            console.log(result.error.flatten().fieldErrors);
            set({error:result.error.flatten().fieldErrors})
            return;
        }
        else{
            set({error:null})
        }
        fetch("/p_preferencia",{
            headers:{"Content-Type": "application/json",},
            method: get().datos.id == 0 ? "POST" : "PUT",
            body: JSON.stringify(get().datos)
        })
        .then((res) => res.json())
        .then((data) => {
            console.log('El dato',data);
            if(data.status == 1){
                // Success
                get().elNavigate(-1);
                get().limpiar();
            }
        })
        .catch((error) => {
            console.log('Error',error);
        });
    },
    obtenerPreferencia: async() => {
        if(get().datos.id != 0){
            await fetch("/p_preferencia",{
                method: "PATCH",
                headers:{"Content-Type": "application/json",},
                body: JSON.stringify({id:get().datos.id})
            })
            .then((res) => res.json())
            .then((data) => {
                if(data.status == 1){
                   set({datos:{
                        ...get().datos,
                        nombre:data.data[0][0].NOMBRE_PRE,
                        sucursales:data.data[1].map((item) => { return { value: item.ID_SUC, label: item.NOMBRE_SUCURSAL_SUC } }),
                        estatus:data.data[0][0].ESTATUS_PRE
                    }});
                }
            })
            .catch((error) => {
                console.log('Error',error);
            });
        }   
    }
})